import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { AuthService } from '../../services/auth.service';
import { ProductService } from '../../services/product.service';
import { ApiResponse } from '../../models/api-response.model';

@Component({
  selector: 'app-send-enquiry',
  templateUrl: './send-enquiry.component.html',
  styleUrls: ['./send-enquiry.component.css']
})
export class SendEnquiryComponent implements OnInit {

  comments = '';
  email = '';
  currentUserModel: CurrentUserModel;

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private productService: ProductService,
    public dialogRef: MatDialogRef<SendEnquiryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.authService.getLoginInfo()
      .subscribe((res: CurrentUserModel) => {
        this.currentUserModel = res;
        this.email = this.currentUserModel.email;
      },
        (error: any) => {
          console.error(error);
        });
  }

  sendEnquiry(): void {
    let flag = false;
    if (!this.comments) {
      flag = true;
      this.commonService.showError('.note-wrapper', 'Enquiry is mandatory', 'right');
    }
    if (!this.email) {
      flag = true;
      this.commonService.showError('.email', 'Email is mandatory', 'right');
    } else if (!this.ValidateEmail(this.email)) {
      flag = true;
      this.commonService.showError('.email', 'Email is not valid', 'right');
    }
    if (!flag) {
      this.productService.SendProductEnquiryEmail(JSON.stringify(this.comments).replace(/\\n/g, '<br />').slice(1, -1), this.email, this.data.item.lr_stock_code, this.data.item.lr_stk_brand, this.data.item.lr_stk_description).subscribe((res: ApiResponse) => {
        if (res.status) {
          this.commonService.showSuccess('.continue', res.responseMessage, 'right');
          setTimeout(() => {
            this.dialogRef.close();
          }, 1500);
        } else {
          this.commonService.showError('.continue', res.responseMessage, 'right');
        }
      },
        (error: any) => {
          console.error(error);
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ValidateEmail(email): boolean {
    const pattern = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,20}$/;
    if (!pattern.test(email) && email !== '') {
      return false;
    } else {
      return true;
    }
  }
}
